import { TickList } from '@/app/components/TickList';
import Image from 'next/image';
import Link from 'next/link';

import { useMediaQuery } from '@material-ui/core';

import styles from './SalaryGuide.module.scss';
import { SalaryGuideForm } from './components/SalaryGuideForm';

type SalaryGuideProps = {
  fullPage?: boolean;
};

export default function SalaryGuide({ fullPage = false }: SalaryGuideProps) {
  const isDesktop = useMediaQuery('(min-width: 1140px)');

  return (
    <div className={styles.salaryGuide}>
      {isDesktop && fullPage === true && (
        <Image
          src="/assets/guide-book.svg"
          priority={false}
          alt=""
          aria-hidden
          width={149}
          height={198}
        />
      )}

      <div>
        <h2 className={styles.salaryGuideTitle}>
          FY26 Australian <span>Salary Guide</span>
        </h2>
        <p className={styles.subHeading}>
          Download our free FY26 guide and get the inside scoop on:
        </p>
        <TickList
          variant="small"
          items={[
            <div key="earning" className={styles.listItem}>
              What doctors <span>are earning</span>
            </div>,
            <div key="trends" className={styles.listItem}>
              <span>Industry trends</span>
            </div>,
            <div key="get-ahead" className={styles.listItem}>
              How to <span>get ahead in 2026</span>
            </div>,
          ]}
        />
        <Link prefetch={false} href="/doctors/resources" as="/doctors/resources">
          <a className={styles.downloadText}>Preview all available resources</a>
        </Link>
      </div>

      <SalaryGuideForm />
    </div>
  );
}
